export enum ProgressBarStatus {
  Done = 'Done',
  Failed = 'Failed',
  Warning = 'Warning',
  Error = 'Error',
}
